import { AppShellNavbar, ScrollAreaAutosize, Stack } from '@mantine/core';
import { listMenu } from './listMenu';
import NavbarBottom from './NavbarBottom';
import NavbarLink from './NavbarLink';
import NavbarText from './NavbarText';
import NavbarTop from './NavbarTop';
import styles from './Navbar.module.css';

const Navbar = () => {
  return (
    <AppShellNavbar bg="#F7F8FA" zIndex={200}>
      <NavbarTop />
      <ScrollAreaAutosize>
        <Stack gap={10} p={16} className={styles.listMenu}>
          {listMenu.map((item, i) => {
            if ('title' in item) {
              return <NavbarText title={item.title} key={`nav-${i}`} />;
            }

            return <NavbarLink key={`nav-${i}`} {...item} />;
          })}
        </Stack>
      </ScrollAreaAutosize>
      <NavbarBottom />
    </AppShellNavbar>
  );
};

export default Navbar;
